import { FC } from "react";
import { PatchServiceAlertReqDto } from "service/api/estabrookSchemas";
import FormField from "../../../shared/components/FormField";
import FormLayout from "../../../shared/components/FormLayout";
import { BaseFormProps } from "../../../shared/types/formTypes";

const NotificationFormServiceAlert: FC<
  BaseFormProps<PatchServiceAlertReqDto>
> = ({ values, handleChange, handleBlur, touched, errors }) => {
  return (
    <FormLayout>
      <FormField
        label="Title"
        id="title"
        placeholder="Enter title"
        value={values.title}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
      />
      <FormField
        label="Message"
        id="message"
        placeholder="Enter message"
        value={values.message}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        multiline
        rows={5}
        labelProps={{ fontWeight: 600, alignSelf: "flex-start" }}
      />
    </FormLayout>
  );
};

export default NotificationFormServiceAlert;
